import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

import { useAtomValue } from 'jotai';

import { DirectMessageService } from '@/components/pages/conversations/SocialInbox/services/DirectMessageService';

import { useSocialInboxDataSource } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxDataSource';
import { useSWRSocket, WEBSOCKET_EVENTS } from '@/utils/hooks/swr/useSWRSocket';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import {
    DMConversation,
    DMConversationRefreshEvent
} from '@/components/pages/conversations/SocialInbox/types';

import { MANAGE_DM_TRACKER } from '@/lib/routes/privateRoutes';

import { openedMessageAtom } from '@/components/pages/conversations/SocialInbox/atoms';

import Icon from '@/components/base/Icon';
import Loader from '@/components/base/Loader';

export const RefreshButton = () => {
    const [isRefreshing, setIsRefreshing] = useState(false);
    const path = usePathname();
    const { activeSocialProfile } = useActiveSocialProfile();
    const { isLoading, isLoadingMore, refreshMessages } = useSocialInboxDataSource();
    const { data: eventData } = useSWRSocket<DMConversationRefreshEvent>();

    const openedMessage = useAtomValue(openedMessageAtom);
    const isDirectMessage = path === MANAGE_DM_TRACKER;

    const handleRefresh = () => {
        if (isDirectMessage) {
            setIsRefreshing(true);

            const promises = [
                DirectMessageService.initiateConversationFetchJob(activeSocialProfile.id)
            ];

            if (openedMessage) {
                promises.push(
                    DirectMessageService.initiateConversationMessageFetchJob(
                        activeSocialProfile.id,
                        (openedMessage as DMConversation).meta_conversation_id
                    )
                );
            }

            Promise.all(promises);

            return;
        }

        refreshMessages();
    };

    useEffect(() => {
        if (eventData?.event === WEBSOCKET_EVENTS.INSTAGRAM_CONVERSATION_REFRESH) {
            setIsRefreshing(false);
        }
    }, [eventData]);

    return isLoading || isLoadingMore || isRefreshing ? (
        <Loader className="size-4 text-icoBlack dark:text-white" />
    ) : (
        <Icon
            icon="refresh"
            className="text-12 cursor-pointer text-icoBlack dark:text-white"
            onClick={handleRefresh}
        />
    );
};
